import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";

import { cn } from "@/lib/utils";
import { LayerScope, keepScrollInLayer, useRaisedLayer } from "./layer";

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(
  (
    {
      className,
      align = "center",
      sideOffset = 4,
      children,
      style,
      onWheel,
      onTouchMove,
      ...props
    },
    forwardedRef
  ) => {
    const layer = useRaisedLayer(className, style, forwardedRef);
    return (
      <HoverCardPrimitive.Portal>
        <HoverCardPrimitive.Content
          ref={layer.ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            "z-50 w-64 overscroll-contain rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 [&_*]:overscroll-contain",
            className
          )}
          style={layer.style}
          onWheel={keepScrollInLayer(onWheel)}
          onTouchMove={keepScrollInLayer(onTouchMove)}
          {...props}
        >
          <LayerScope z={layer.z}>{children}</LayerScope>
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    );
  }
);
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
